import { theme } from './theme'

export const descriptionVariants = {
  initial: (direction: number) => ({
    opacity: 0,
    translateX: direction > 0 ? '3rem' : '-3rem',
  }),
  visible: {
    opacity: 1,
    translateX: 0,
    transition: { duration: 0.5, ease: theme.ease.out },
  },
  hidden: (direction: number) => ({
    opacity: 0,
    translateX: direction < 0 ? '3rem' : '-3rem',
    transition: { duration: 0.35, ease: theme.ease.out },
  }),
}

export const modalDescriptionVariants = {
  initial: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    translateX: 0,
    transition: { duration: 0.5, ease: theme.ease.out },
  },
  hidden: {
    opacity: 0,
    transition: { duration: 0.5, ease: theme.ease.out },
  },
}
